import { useState } from 'react';

import { Phone } from '~components/AllianceCallService/AllianceCallService';
import Anchor from '~components/Anchor/Anchor';
import Button from '~components/Button/Button';
import FormDisclaimer from '~components/FormDisclaimer/FormDisclaimer';
import EmailLeadForm from '~components/LeadForm/EmailLeadForm/EmailLeadForm';
import Modal from '~components/ModalDialog/ModalDialog';
import { fireCloseModal } from '~globals/tracking';
import { useAppSelector } from '~hooks/useRedux';
import useWindowSize from '~hooks/useWindowSize';
import CalendarIcon from '~images/inline/calendar-black.inline.svg';
import GuideIcon from '~images/inline/guide.inline.svg';
import PhoneIcon from '~images/inline/phone-green.inline.svg';

import success from '../images/success.png';

type Props = { isOpen: boolean; setIsOpen: (a: boolean) => void };

const NtmExit = ({ isOpen, setIsOpen }: Props) => {
    const [isSuccess, setIsSuccess] = useState(false);
    const { isMobile } = useWindowSize();
    const throttle = useAppSelector((state) => state.global.throttle);
    const customDisclaimer =
        'You consent to receive marketing emails from eHealth. Your information and use of this site is governed by our most recent ';

    const handleSuccess = () => {
        setIsSuccess(true);
    };

    const handleClose = () => {
        fireCloseModal();
        setIsOpen(false);
    };

    const waLink: string = process.env.GATSBY_ANALYTICS_SITE_GROUP + ':header:schedule appointment';

    return (
        <Modal isOpen={isOpen} setIsOpen={setIsOpen} disablePadding>
            {throttle && throttle !== 'RED' ? (
                <div className="text-center px-14 pt-10 pb-6 bg-white">
                    <h2 className="font-poppins text-[#DC188E] text-32 leading-40 font-bold mb-3 md:text-40 md:leading-56 lg:text-48 lg:leading-64 lg:mb-6">
                        We&apos;re here to help!
                    </h2>
                    <p className="font-poppins text-20 leading-28 font-semibold lg:text-24 lg:leading-32">
                        Speak with an eHealth licensed insurance
                        <br /> agent with expertise in your area.
                    </p>

                    <p className="mt-6 flex justify-center items-center lg:mt-12">
                        <PhoneIcon />
                        <Phone
                            classname="text-[#DC188E] font-poppins text-48 leading-62 font-bold mx-2 md:text-32 md:leading-40 lg:text-48 lg:leading-62"
                            isbtn={isMobile ? 'rebrandAction' : undefined}
                        />
                        <span className="text-48 leading-62 font-light md:text-32 md:leading-40 lg:text-48 lg:leading-62">
                            TTY 711
                        </span>
                    </p>
                    <div className="flex justify-center mt-3">
                        <Anchor
                            to="/schedule-appointment"
                            className="flex items-center ml-2 text-primary hover:underline"
                            data-wa-link={waLink}
                        >
                            <CalendarIcon fill="black" className="mr-2" />
                            Schedule a call
                        </Anchor>
                    </div>
                </div>
            ) : (
                <></>
            )}
            <div className="bg-surface-100 px-14 py-10">
                {!isSuccess ? (
                    <>
                        <p className="font-poppins text-20 leading-28 text-center font-bold lg:text-32 lg:leading-48">
                            Get your free New to Medicare guide
                        </p>

                        <div className="flex justify-center items-center mt-3 mb-6">
                            <GuideIcon />
                            <p className="ml-4 text-center text-16 leading-24 font-semibold lg:text-20 lg:leading-28">
                                Learn how to make the most of your
                                <br /> first-time Medicare enrollment.
                            </p>
                        </div>
                        <div className="w-72 m-auto">
                            <EmailLeadForm
                                buttonText="Get my guide"
                                formPlaceholder="Enter your email"
                                isLabelHidden
                                className="my-4"
                                mktoFormId={1004}
                                isStacked={true}
                                leadInfo={{ advertiseSource: 'EHMExitNTM' }}
                                onSuccess={handleSuccess}
                                qaInput="ntm-exit-input"
                                uid="ntm-exit-cta"
                                leadTrackingAction={{ page: { action: 'sign me up' } }}
                            />
                        </div>
                        <FormDisclaimer
                            customDisclaimer={customDisclaimer}
                            className="pb-4 md:pb-0"
                        />
                    </>
                ) : (
                    <div className="flex flex-col items-center">
                        <p className="font-poppins text-20 leading-28 text-center font-bold lg:text-32 lg:leading-48">
                            Success!
                        </p>
                        <div className="flex justify-center items-center mt-3 mb-12">
                            <img src={success} alt="" width="64" />
                            <p className="ml-4 text-center text-16 leading-24 font-semibold lg:text-20 lg:leading-28">
                                Your free guide is on the way.
                            </p>
                        </div>
                        <Button onClick={handleClose} className="w-72">
                            Close
                        </Button>
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default NtmExit;
